import React, { useEffect } from 'react';
import { playSpookySound } from './spookyAudio';
import { HalloweenBatIcon } from './HalloweenIcons';

const HalloweenFog = ({ isLightningActive, burstBats, onTriggerScare }) => {
    // Ambient occasional lightning strike (every 32-48 seconds)
    useEffect(() => {
        const scheduleLightning = () => {
            const nextDelay = 32000 + Math.random() * 16000;
            return setTimeout(() => {
                if (onTriggerScare) {
                    playSpookySound('thunder');
                    onTriggerScare();
                }
                timer = scheduleLightning();
            }, nextDelay);
        };

        let timer = scheduleLightning();
        return () => clearTimeout(timer);
    }, [onTriggerScare]);

    return (
        <>
            {/* Screen Lightning Flash Overlay */}
            {isLightningActive && (
                <div className="fixed inset-0 z-[72] pointer-events-none animate-lightning bg-indigo-950/40 mix-blend-screen" />
            )}

            {/* Flying Bat Swarm on Scare Burst */}
            {burstBats && burstBats.length > 0 && (
                <div className="fixed inset-0 z-[73] pointer-events-none overflow-hidden">
                    {burstBats.map((bat) => (
                        <div
                            key={bat.id}
                            className="absolute animate-bat-burst select-none"
                            style={{
                                left: `${bat.startX}%`,
                                bottom: `${bat.startY}%`,
                                '--tx': `${bat.tx}px`,
                                '--ty': `${bat.ty}px`,
                                '--rot': `${bat.rot}deg`,
                                animationDuration: `${bat.duration}s`,
                                animationDelay: `${bat.delay}s`,
                            }}
                        >
                            <HalloweenBatIcon className="w-8 h-8 md:w-10 md:h-10 text-stone-900 drop-shadow-[0_2px_8px_rgba(234,88,12,0.65)]" />
                        </div>
                    ))}
                </div>
            )}

            {/* Eerie Ambient Vignette (Layered strictly behind interactive UI) */}
            <div className="fixed inset-0 pointer-events-none z-[1] bg-[radial-gradient(circle_at_center,transparent_65%,rgba(5,2,10,0.25)_100%)]" />

            {/* Bottom Multi-layer Rolling Fog (Layered behind interactive cards & buttons) */}
            <div className="fixed bottom-0 left-0 right-0 h-36 md:h-48 pointer-events-none z-[2] overflow-hidden">
                {/* Back Fog Layer (Slow drift) */}
                <div
                    className="absolute inset-0 bg-gradient-to-t from-purple-950/45 via-purple-900/15 to-transparent w-[200%] animate-fog-slow"
                    style={{ maskImage: 'radial-gradient(ellipse at bottom, black 50%, transparent 80%)' }}
                />
                {/* Front Fog Layer (Faster drift + orange embers tint) */}
                <div
                    className="absolute inset-0 bg-gradient-to-t from-gray-950/60 via-orange-950/20 to-transparent w-[200%] animate-fog-fast"
                    style={{ maskImage: 'radial-gradient(ellipse at bottom, black 60%, transparent 90%)' }}
                />
            </div>
        </>
    );
};

export default HalloweenFog;
